import(/* webpackMode: "eager" */ "/root/www/.buckydao-build-1607de7/src/app/(pages)/funding/page.tsx");
